import React from 'react';
import classnames from 'classnames';
import { PapiUser } from '@wix/da-papi-types';

import SocialLink from '../SocialLink';
import s from './SocialMediaList.scss';

interface Props {
  socialLinks: {
    id: number;
    value?: string;
  }[];
  user: PapiUser;
}

const SocialMediaList: React.FC<Props> = ({
  socialLinks,
  user: { username },
}) => (
  <div
    className={classnames(
      s['root'],
      socialLinks.length >= 6 && s['a-lot-of-social-media']
    )}
  >
    {socialLinks.map(
      (socialLink, index) =>
        socialLink.value && (
          <SocialLink
            key={index}
            username={username}
            networkId={socialLink.id}
            url={socialLink.value}
            className={s['social-media-link']}
          />
        )
    )}
  </div>
);
SocialMediaList.displayName = 'SocialMediaList';

export default SocialMediaList;
